// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { CompleteResetAuthPasswordResetCompletePostMutationRequest, CompleteResetAuthPasswordResetCompletePostMutationResponse, CompleteResetAuthPasswordResetCompletePost400, CompleteResetAuthPasswordResetCompletePost410, CompleteResetAuthPasswordResetCompletePost422 } from "../models/emailAuthController/CompleteResetAuthPasswordResetCompletePost.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";
import type { MutationObserverOptions, QueryClient } from "@tanstack/vue-query";
import type { MaybeRefOrGetter } from "vue";
import { completeResetAuthPasswordResetCompletePost } from "../client/completeResetAuthPasswordResetCompletePost.ts";
import { useMutation } from "@tanstack/vue-query";

export const completeResetAuthPasswordResetCompletePostMutationKey = () => [{ url: '/auth/password/reset/complete' }] as const

export type CompleteResetAuthPasswordResetCompletePostMutationKey = ReturnType<typeof completeResetAuthPasswordResetCompletePostMutationKey>

/**
 * @description Complete password reset.
 * Verifies code and sets new password.
 * @summary Complete Reset
 * {@link /auth/password/reset/complete}
 */
export function useCompleteResetAuthPasswordResetCompletePost<TContext>(options: 
{
  mutation?: MutationObserverOptions<CompleteResetAuthPasswordResetCompletePostMutationResponse, ResponseErrorConfig<CompleteResetAuthPasswordResetCompletePost400 | CompleteResetAuthPasswordResetCompletePost410 | CompleteResetAuthPasswordResetCompletePost422>, {data: MaybeRefOrGetter<CompleteResetAuthPasswordResetCompletePostMutationRequest>}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CompleteResetAuthPasswordResetCompletePostMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions?.mutationKey ?? completeResetAuthPasswordResetCompletePostMutationKey()

          return useMutation<CompleteResetAuthPasswordResetCompletePostMutationResponse, ResponseErrorConfig<CompleteResetAuthPasswordResetCompletePost400 | CompleteResetAuthPasswordResetCompletePost410 | CompleteResetAuthPasswordResetCompletePost422>, {data: CompleteResetAuthPasswordResetCompletePostMutationRequest}, TContext>({
            mutationFn: async({ data }) => {
              return completeResetAuthPasswordResetCompletePost(data, config)
            },
            mutationKey,
            ...mutationOptions
          }, queryClient)
      
}